import { render, staticRenderFns } from "./LeftSidebarComm.vue?vue&type=template&id=caf7384e&"
import script from "./LeftSidebarComm.vue?vue&type=script&lang=js&"
export * from "./LeftSidebarComm.vue?vue&type=script&lang=js&"
import style0 from "./LeftSidebarComm.vue?vue&type=style&index=0&id=caf7384e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports